module.exports = __webpack_public_path__ + "static/media/Skull.79f91944.svg";